import '@ospace/styles/assets/sass/style.scss'

import { App } from '@ospace/entry'
import '@mantine/notifications/styles.css'
import { initDataDog } from '@ospace/shared/services/datadog'
import { Chart, registerables } from 'chart.js'
import { createRoot } from 'react-dom/client'

async function enableMocking() {
  if (import.meta.env.MODE !== 'development') {
    return
  }

  if (import.meta.env.VITE_MOCK_API !== 'true') {
    return
  }

  const { worker } = await import('./mocks/browser')
  console.log('Starting mock worker')
  // `worker.start()` returns a Promise that resolves
  // once the Service Worker is up and ready to intercept requests.
  return worker.start()
}

// if in production, init DataDog
if (import.meta.env.MODE === 'production') {
  initDataDog()
}
const container = document.getElementById('root')

Chart.register(...registerables)
enableMocking().then(() => {
  const root = createRoot(container!)
  root.render(<App />)
})
